export default __webpack_public_path__ + "static/media/me.039b45a1.png";